import { useWorker } from './useWorker';

export const useUser = () => {
  const { user } = useWorker();
  return user;
};
